import classNames from "classnames";
import { ReactNode } from "react";

interface Props {
  Icon: ReactNode;
  className?: string;
  text?: string | number;
  textClassName?: string;
  onClick?: VoidFunction;
  active?: boolean;
}

export default function MemoCardButton(props: Props) {
  const container = classNames(
    'w-[33px] h-[33px] flex flex-row gap-1 ml-0 items-center justify-center cursor-pointer',
    props.className,
    {
      'text-memod-green-base': props.active,
      'text-[#A7ABAA]': !props.active
    }
  );
  return (
    <div className={container} onClick={props.onClick}>
      {props.Icon}
      <span className={classNames("text-xs text-base-white", props.textClassName)}>{props.text}</span>
    </div>
  );
}